var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ui basic padded segment" },
    [
      _c("div", { staticClass: "ui divider horizontal header" }, [
        _c("i", { staticClass: "user icon" }),
        _vm._v(_vm._s(_vm.$t("pages.profile.settings.profile.header")))
      ]),
      _vm._v(" "),
      _c("profile-settings", { ref: "ProfileSettings" }),
      _vm._v(" "),
      _c("div", { staticClass: "ui divider horizontal header" }, [
        _c("i", { staticClass: "file icon" }),
        _vm._v(
          "\n      " +
            _vm._s(_vm.$t("pages.profile.settings.documentation.header")) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("documentation-settings", { ref: "DocumentationSettings" }),
      _vm._v(" "),
      _c("div", { staticClass: "ui divider horizontal header" }, [
        _vm._m(0),
        _vm._v(
          "\n\t\t\t" +
            _vm._s(_vm.$t("pages.profile.settings.privacy.header")) +
            "\n\t\t"
        )
      ]),
      _vm._v(" "),
      _c("privacy-settings", { ref: "PrivacySettings" })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("i", { staticClass: "large icons" }, [
      _c("i", { staticClass: "shield alternate icon" }),
      _vm._v(" "),
      _c("i", { staticClass: "bottom right corner setting icon" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24e06492", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24e06492","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/ProfileSettings.vue
// module id = /ZY5
// module chunks = 1